(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  function initializeStrummerArticles(root) {
    if (root.dataset.articlesReady === 'true') return;

    const track = root.querySelector('.strummer-articles__track');
    const buttons = root.querySelectorAll('[data-articles-direction]');

    if (!track || buttons.length === 0) return;

    root.dataset.articlesReady = 'true';

    const updateButtons = () => {
      const maximumScroll = track.scrollWidth - track.clientWidth;

      buttons.forEach((button) => {
        const direction = Number(button.dataset.articlesDirection);
        button.disabled = direction < 0 ? track.scrollLeft <= 1 : track.scrollLeft >= maximumScroll - 1;
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const firstCard = track.querySelector('.strummer-articles__card');
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth;

        track.scrollBy({
          left: distance * Number(button.dataset.articlesDirection),
          behavior: 'smooth'
        });
      });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  document.querySelectorAll('[data-strummer-articles]').forEach(initializeStrummerArticles);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-strummer-articles]').forEach(initializeStrummerArticles);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  function initializeFeaturedCollection(section) {
    if (section.dataset.carouselReady === 'true') return;

    const scroller = section.querySelector('.featured-collection__scroller');
    const previous = section.querySelector('[data-featured-previous]');
    const next = section.querySelector('[data-featured-next]');

    if (!scroller || !previous || !next) return;

    section.dataset.carouselReady = 'true';

    const updateControls = () => {
      const maximumScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      previous.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= maximumScroll - 2;
    };

    const scrollProducts = (direction) => {
      scroller.scrollBy({ left: direction * scroller.clientWidth * 0.85, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollProducts(-1));
    next.addEventListener('click', () => scrollProducts(1));
    scroller.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  document.querySelectorAll('.featured-collection-section').forEach(initializeFeaturedCollection);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.featured-collection-section');
    if (section) initializeFeaturedCollection(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function initializeStrummerRecommendations(root) {
    if (root.dataset.strummerRecommendationsReady === 'true') return;
    root.dataset.strummerRecommendationsReady = 'true';

    // Shopify inserts the actual recommendations after this section first loads.
    const bindCarousel = () => {
      const scroller = root.querySelector('[data-recs-scroller]');
      const previous = root.querySelector('[data-recs-previous]');
      const next = root.querySelector('[data-recs-next]');

      if (!scroller || !previous || !next || root.strummerScroller === scroller) return;
      root.strummerScroller = scroller;

      const updateControls = () => {
        const maximumScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        previous.disabled = maximumScroll <= 2 || scroller.scrollLeft <= 2;
        next.disabled = maximumScroll <= 2 || scroller.scrollLeft >= maximumScroll - 2;
      };
      root.strummerUpdateControls = updateControls;

      previous.addEventListener('click', () => {
        scroller.scrollBy({ left: -scroller.clientWidth * 0.85, behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        scroller.scrollBy({ left: scroller.clientWidth * 0.85, behavior: 'smooth' });
      });

      scroller.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });
      updateControls();
    };

    const refreshCarousel = () => {
      bindCarousel();
      const track = root.querySelector('.strummer-recs__track');
      if (track && track.querySelector('.grid-product')) {
        if (root.strummerImageTrack !== track) {
          root.strummerImageTrack = track;
          requestAnimationFrame(() => {
            if (root.isConnected && window.AOS && typeof window.AOS.refreshHard === 'function') {
              window.AOS.refreshHard();
            }
          });
        }
        root.classList.add('strummer-recommendations-loaded');
        root.strummerUpdateControls?.();
      }
    };

    new MutationObserver(refreshCarousel).observe(root, { childList: true, subtree: true });
    refreshCarousel();

    // Load recommendations independently so the carousel works when the theme's
    // older recommendations loader only hides the placeholder.
    if (!root.querySelector('.strummer-recs__track') && root.dataset.url) {
      fetch(root.dataset.url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations unavailable');
          return response.text();
        })
        .then((html) => {
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const track = documentFragment.querySelector('.strummer-recs__track');
          if (!track || !track.querySelector('.grid-product')) return;

          const scroller = root.querySelector('[data-recs-scroller]');
          if (!scroller) return;
          scroller.replaceChildren(track);
          root.classList.remove('hide');
          refreshCarousel();
          requestAnimationFrame(() => root.strummerUpdateControls());
        })
        .catch(() => {});
    }
  }

  document.querySelectorAll('product-recommendations.strummer-product-recommendations')
    .forEach(initializeStrummerRecommendations);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('product-recommendations.strummer-product-recommendations')
      .forEach(initializeStrummerRecommendations);
  });

  } catch(e) { console.error(e); }
})();
})();
